import React, { useState } from 'react'
import { IMaskInput } from 'react-imask';
import { Autocomplete, TextField, createFilterOptions } from '@mui/material';
import { getPhoneNumber } from 'hajjtravel-utils';
import { COUNTRIES, findCountry } from './countries';
import './phone-input.scss'

// Поиск страны по названию, коду (7, +7) и ISO (KZ)
const filterCountries = createFilterOptions({
    stringify: (c) => `${c.name} ${c.code} +${c.code} ${c.iso}`,
});

/**
 * phoneNumber - полный номер телефона с кодом: 77772001991
 * countryCode - код страны: например, для Казахстана 7
 * onChange - получает { countryCode, phone }, где phone — полный номер с кодом страны
 * autoComplete - подсказка браузеру для автозаполнения (например, "tel-national")
 * error - текст ошибки: поле подсвечивается красным, текст выводится под ним
 * onBlur - вызывается, когда поле номера теряет фокус
 */
export const PhoneInput = ({ phoneNumber, onChange, countryCode = 7, hideLabel = false, autoComplete, error, onBlur }) => {
    // Выбранная страна. Нужна, чтобы различать страны с общим кодом (+7 — Казахстан и Россия)
    const [selectedIso, setSelectedIso] = useState(null)
    const country = findCountry(countryCode, selectedIso)

    // Здесь мы извлекаем только номер
    phoneNumber = getPhoneNumber(phoneNumber, country.code)

    return (
        <div style={{ width: 'inherit' }}>
            <div className={`phone-input ${error ? 'phone-input--error' : ''}`}>
                <div className='phone-input__country'>
                    <Autocomplete
                        disableClearable
                        autoHighlight
                        selectOnFocus
                        options={COUNTRIES}
                        value={country}
                        filterOptions={filterCountries}
                        isOptionEqualToValue={(option, value) => option.iso === value.iso}
                        getOptionLabel={(c) => `+${c.code}`}
                        onChange={(_, c) => {
                            setSelectedIso(c.iso)
                            onChange({
                                countryCode: c.code,
                                phone: ''
                            })
                        }}
                        renderOption={(props, c) => {
                            const { key, ...optionProps } = props
                            return (
                                <li key={c.iso} {...optionProps}>
                                    <span className='phone-option__flag'>{c.flag}</span>
                                    <span className='phone-option__name'>{c.name}</span>
                                    <span className='phone-option__code'>+{c.code}</span>
                                </li>
                            )
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                error={Boolean(error)}
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: <span className='phone-option__flag'>{country.flag}</span>,
                                }}
                            />
                        )}
                        slotProps={{ popper: { placement: 'bottom-start', style: { width: 320 } } }}
                    />
                </div>
                <div className='phone-input__phone'>
                    <IMaskInput
                        // При смене страны меняется маска — пересоздаём поле
                        key={country.iso}
                        mask={country.mask}
                        placeholderChar='_'
                        lazy={false}
                        style={{ padding: '1rem' }}
                        value={phoneNumber}
                        unmask={true}
                        type='tel'
                        autoComplete={autoComplete}
                        placeholder='Номер телефона'
                        onBlur={onBlur}
                        onAccept={(value) => {
                            onChange({
                                countryCode: country.code,
                                phone: `${country.code}${value}`
                            })
                        }}
                    />
                </div>
            </div>
            {error && <div className='phone-input__error'>{error}</div>}
            {hideLabel ? null : <div className='fs-12 color-gray m-t-8'>Номер телефона Whatsapp. Будет использоваться как основной вход в систему</div>}
        </div>
    )
}
